import React, { useState } from 'react'
import { ZinButton, ZinIcon } from '@tnl/zin-react'
import { IOwner } from '@features/account/types'
import { PROFILE_MANAGE_PASSWORD_LABEL, PROFILE_EDIT_BUTTON_TEXT } from '@constants'
import './ProfilePasswordBox.scss'
import { ChangePasswordForm } from '../ProfileAvatar/ChangePasswordForm'

interface ProfilePasswordBoxProps {
  owner: IOwner
}

const ProfilePasswordBox: React.FC<ProfilePasswordBoxProps> = ({ owner }) => {
  const [isEditingPassword, setIsEditingPassword] = useState(false)

  const handleSavePassword = () => {
    setIsEditingPassword(false)
  }

  const handleCancelPassword = () => {
    setIsEditingPassword(false)
  }

  return (
    <div className="mk-profile__password-box">
      <div className="mk-profile__password-box-header">
        <ZinIcon
          name="passport"
          className="mk-profile__password-icon"
          size="lg"
          set="fal"
        />
        <div className="mk-profile__password-label-container">
          <label className="mk-profile__password-label caption-2">{PROFILE_MANAGE_PASSWORD_LABEL}</label>
          <div className="mk-profile__password-display">{owner.passwordMask || '********'}</div>
        </div>
      </div>
      {!isEditingPassword ? (
        <>
          <ZinButton
            variant="primary"
            className="mk-profile__password-button"
            onClick={() => setIsEditingPassword(true)}>
            {PROFILE_EDIT_BUTTON_TEXT}
          </ZinButton>
        </>
      ) : (
        <ChangePasswordForm
          owner={owner}
          onCancel={handleCancelPassword}
          onSave={handleSavePassword}
        />
      )}
    </div>
  )
}

export default ProfilePasswordBox
